module.exports = __webpack_public_path__ + "img/lesson.b04db60f.svg";